<canvas #theCanvas [width]="width" [height]="height"></canvas>
